import React, { useContext } from 'react'
import Cart from '@svgs/cart.svg'
import Login from '@svgs/login.svg'
import style from './header.mod.scss'
import { Button, Menu, Logo } from '@components'
import BarsSvg from '@svgs/bars.svg'
import CloseSvg from '@svgs/close.svg'
import ThemeContext from '@context/themeContext'
import { gtmPush } from '@helpers/gtmHelpers'

const Header = ({ menuItems, lowOpacity }) => {
  const modifiers = []

  lowOpacity && modifiers.push(style['header--low-opacity'])

  return (
    <header className={[style.header, ...modifiers].join(' ')}>
      <div className={style.header__container}>
        <div className={style.header__wrapper}>
          <div className={style.header__logo}>
            <Logo />
          </div>
          <div className={style.header__menu}>
            <Menu items={menuItems} />
          </div>
          <div className={style.header__controls}>
            <div className={style.header__button}>
              <Button
                to="https://dedikate.com"
                onClick={() => {
                  gtmPush({
                    event: `dedikate-click`,
                    label: `Header Link`,
                    value: `Start 7 Day Free Trial`
                  })
                }}
              >
                {'Start 7 Day Free Trial'}
              </Button>
            </div>
            <div className={style.header__login}>
              <Button
                unstyled
                to={'https://dedikate.com'}
                onClick={() => {
                  gtmPush({
                    event: `dedikate-click`,
                    label: `Header Link`,
                    value: `Login`
                  })
                }}
              >
                <Login />
                <p>Login</p>
              </Button>
            </div>
            <div className={style.header__bars}>
              <ThemeContext.Consumer>
                {({ toggleSidebar, isSidebarOpen }) => {
                  return (
                    <div onClick={() => toggleSidebar()}>
                      {isSidebarOpen ? <CloseSvg /> : <BarsSvg />}
                    </div>
                  )
                }}
              </ThemeContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
